import {Injectable} from '@angular/core';
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {Router} from '@angular/router';
import {catchError, map} from 'rxjs/operators';
import {SKIP_INTERCEPTORS_HEADER_CONST} from '../helpers/request.helper';
import {NotificationService} from '../services/notification.service';
import {Store} from '@ngxs/store';
import {LOGIN_REQUEST_URL} from '../services/auth.service';
import {AuthActions} from '../state/auth/auth.actions';
import {NavService} from '../services/nav.service';
import {NavItemCodes} from '../enums/nav-item-codes.enum';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
    constructor(
        private router: Router,
        private store: Store,
        private notificationService: NotificationService,
        private navService: NavService,
    ) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const clonedReq = req.clone();
        return next.handle(clonedReq).pipe(
            map((event) => {
                return event;
            }),
            catchError((error) => {
                const skipInterceptors = clonedReq?.headers?.get(SKIP_INTERCEPTORS_HEADER_CONST);
                if ((skipInterceptors && skipInterceptors.indexOf(error.status) === -1) || !skipInterceptors) {
                    switch ((error as HttpErrorResponse).status) {
                        case 400:
                            this.notificationService.error('ERRORS.REQUEST_RESPONSE_400');
                            break;
                        case 401:
                            if (!error.url.endsWith(LOGIN_REQUEST_URL)) {
                                this.notificationService.error('ERRORS.REQUEST_RESPONSE_401');
                                this.store.dispatch(new AuthActions.Logout());
                            }
                            break;
                        case 403:
                            this.notificationService.error('ERRORS.REQUEST_RESPONSE_403');
                            this.store.dispatch(new AuthActions.ReloadCurrentUser());
                            this.navService.navigateByCode(NavItemCodes.HOME);
                            break;
                        case 404:
                            this.notificationService.error('ERRORS.REQUEST_RESPONSE_404');
                            break;
                        case 406:
                            this.notificationService.error(error.error.message);
                            break;
                        case 413:
                            this.notificationService.error('ERRORS.FILE_TOO_BIG');
                            break;
                        case 422:
                            break;
                        case 500:
                            this.notificationService.error('ERRORS.REQUEST_RESPONSE_500');
                            break;
                        default:
                            this.notificationService.error('ERRORS.REQUEST_DEFAULT_ERROR');
                            break;
                    }
                }
                return throwError(error);
            }),
        );
    }
}
